import React from "react";
import { Box, Stack } from "@mui/material";
import { footerStyle } from "./footerStyle";
import dayjs from "dayjs";
import Logo from "@/src/components/Logo/Logo.tsx";
import Typography from "@mui/material/Typography";
import FooterLinkList from "@/src/components/Footer/FooterLinkList.tsx";
import FooterBackgroundImage from "@/src/components/Footer/FooterBackgroundImage.tsx";
import { Link } from "react-router";
import FooterLinkListLegal from "@/src/components/Footer/FooterLinkListLegal.tsx";
import linkedInLogoBase64 from "@/src/assets/img/generic/linked_in_logo.png?inline";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { useFlexServiceLayoutForCustomer } from "@/src/services/advocardService";

type FooterProps = {
  hideProductLinks?: boolean;
};

export default function Footer({ hideProductLinks = false}: FooterProps) {
  const { customer } = useCustomer();
  const isLoggedIn = !!customer;

  return (
    <Box component={"footer"} sx={footerStyle.footer}>
      <FooterBackgroundImage sx={footerStyle.backgroundImage} />
      <Stack sx={!isLoggedIn ? footerStyle.content : footerStyle.contentLoggedIn} direction={{ xs: "column", lg: "row" }}>
        <Stack sx={footerStyle.brand}>
          <Logo variant={"white"} sx={!isLoggedIn ? footerStyle.brandLogo : footerStyle.brandLogoLoggedIn} />
          {!isLoggedIn && <Typography variant={"h5"} component="p">Rechtliche Sicherheit, wenn Sie sie brauchen!</Typography>}
        </Stack>
        {!isLoggedIn && (
          <Box sx={footerStyle.links}>
            <FooterLinkList
              title={"Legalbird"}
              links={[
                {
                  to: "/",
                  label: "Home",
                },
                {
                  to: "/ueber-uns",
                  label: "Über uns",
                },
                {
                  to: "/kontakt",
                  label: "Kontakt",
                },
                {
                  to: "/jobs",
                  label: "Jobs",
                },
                {
                  to: "/lp/partneranwalt-werden",
                  label: "Partneranwalt werden",
                },
              ]}
            />
            {!hideProductLinks && (
              <FooterLinkList
                title={"Rechtsbereiche"}
                links={[
                  {
                    to: "/vertragsrecht",
                    label: "Vertragsrecht",
                  },
                  {
                    to: "/mietrecht",
                    label: "Mietrecht",
                  },
                  {
                    to: "/verkehrsrecht",
                    label: "Verkehrsrecht",
                  },
                  {
                    to: "/familienrecht",
                    label: "Familienrecht",
                  },
                  {
                    to: "/arbeitsrecht",
                    label: "Arbeitsrecht",
                  },
                  {
                    to: "/allgemeines-zivilrecht",
                    label: "Allgemeines Zivilrecht",
                  },
                ]}
              />
            )}
            <FooterLinkListLegal />
          </Box>
        )}
        {isLoggedIn && (
          <FooterLinkListLegal
            title={""}
            spacing={{ lg: "4rem" }}
            direction={"row"}
            sx={(theme) => ({
              [theme.breakpoints.up("lg")]: {
                marginTop: "1rem",
              },
            })}
          />
        )}
      </Stack>
      <Stack direction={"row"} sx={footerStyle.meta}>
        <Box>© Legalbird {dayjs().format("YYYY")}</Box>
        {!isLoggedIn && (
          <Box sx={footerStyle.linkedInLink} component={Link} to={"https://de.linkedin.com/company/legalbird"} target={"_blank"}>
            <img src={linkedInLogoBase64} width={40} alt={"Zu unserem LinkedIn Profil"} />
          </Box>
        )}
      </Stack>
    </Box>
  );
}
